import { Combobox } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type KmNoteSetPickerProps = {
  options: { value: number; label: string }[];
  /** Сколько наборов пришло с сервера */
  loadedCount: number;
  /** Сколько наборов есть в модели знаний всего */
  total: number;
  placeholder: string;
  onSelect: (value: unknown) => void;
};

/**
 * Выбор набора нод знаний из модели знаний. Наборы читаются одним окном, поэтому при
 * усечённой выдаче пользователю говорится, что показаны не все.
 */
export const KmNoteSetPicker: FC<KmNoteSetPickerProps> = ({ options, loadedCount, total, placeholder, onSelect }) => {
  const { t } = useTranslation('expertReport');

  return (
    <div className="space-y-1">
      <Combobox options={options} onChange={onSelect} placeholder={placeholder} />
      {total > loadedCount && (
        <div className="text-xs text-muted-foreground">{t('km.noteSetsTruncated', { count: loadedCount, total })}</div>
      )}
    </div>
  );
};
